/* eslint-disable import/order */
import React from "react";
import { createRoot } from "react-dom/client";
import "./css/app.css";
import { applyBrandTheme } from "src/brands/apply-theme";
import { restorePendingBrand } from "src/brands/restore-brand";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Notification } from "./components/notification";
import store from "./redux/store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import Alert from "react-s-alert";
import * as Sentry from "@sentry/react";
import "./i18n";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/stackslide.css";

const persistor = persistStore(store);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/explore\.cialfo\.co/,
    /^https:\/\/explore-beta\.cialfo\.link/,
  ],
  release: process.env.REACT_APP_SENTRY_RELEASE || "development",
  environment: process.env.REACT_APP_ENVIRONMENT || "development",
});

// An OAuth provider returns to a fixed redirect URI carrying only its own
// params, so the brand has to go back on the URL before anything reads it --
// both the theme below and BrandProvider resolve it exactly once, at boot.
restorePendingBrand();

// Resolve the brand from ?brand=<id> and inject its colors before first paint.
applyBrandTheme();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
      <Alert contentTemplate={Notification} stack={{ limit: 3 }} />
    </PersistGate>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
